/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LevelGateOperator = {
    ANY: 'ANY',
    ALL: 'ALL'
} as const;
export type LevelGateOperator = typeof LevelGateOperator[keyof typeof LevelGateOperator];


export function instanceOfLevelGateOperator(value: any): boolean {
    for (const key in LevelGateOperator) {
        if (Object.prototype.hasOwnProperty.call(LevelGateOperator, key)) {
            if (LevelGateOperator[key as keyof typeof LevelGateOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LevelGateOperatorFromJSON(json: any): LevelGateOperator {
    return LevelGateOperatorFromJSONTyped(json, false);
}

export function LevelGateOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): LevelGateOperator {
    return json as LevelGateOperator;
}

export function LevelGateOperatorToJSON(value?: LevelGateOperator | null): any {
    return value as any;
}

export function LevelGateOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): LevelGateOperator {
    return value as LevelGateOperator;
}

